<template>
  <div id="app">
    <LoadingOverlay v-if="this.loading" />
    <router-view @authenticated="setAuthenticated" />
  </div>
</template>

<script>
import LoadingOverlay from '@/components/LoadingOverlay.vue'

export default {
  name: 'app',
  components: {
    LoadingOverlay
  },
  data() {
    return {
      authenticated: false,
      mockAccount: {
        password: "apcollege_2019"
      }
    }
  },
  computed: {
    loading() {
      return this.$store.state.isLoading
    }
  },
  methods: {
      setAuthenticated(status) {
          this.$store.dispatch('setAuthenticated', { status: status })
      },
      logout() {
          this.$store.dispatch('setAuthenticated', { status: false })
      }
  },
  mounted() {
    if(!this.$store.state.isAuthenticated) {
      this.$router.replace({ name: "login" });
    }
  },
}
</script>


<style lang="scss">
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Arvo', serif;
  font-family: 'Roboto Condensed', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  height: 100%;
  -webkit-perspective: 800px;
  perspective: 800px;
  overflow-x: hidden;
}

h1 {
  font-family: 'Arvo', serif;
  color: #F98B02;
  margin-top:0;
  font-weight: normal;
  letter-spacing: -0.5px;
}

.horizontal-layout {
  width: 55%;
  z-index: 0;
  text-align: left;
  position: absolute;
  top: 0;
  right: 0;

  p {
    font-size: 20px;
    line-height: 28px;
    padding-right: 50px;
  }
}

.vertical-layout {
  width: 85%;
  z-index: 0;
  text-align: left;
  position: absolute;
  top: 20%;
  left: 52px;
  padding-top: 10%;
  
  p {
    font-size: 20px;
    line-height: 24px;
    width: 95%;
  }
}

.store {
  margin-bottom:0;
  font-weight: bold;
  text-transform: uppercase;
}

.slide {
  background: rgb(0,0,0);
  background: linear-gradient(315deg, rgba(0,0,0,1) 0%, rgba(65,65,65,1) 100%);
  height: 100%;
}

</style>
